import CreateAccount from './CreateAccount';
import ListUsers from './ListUsers';
import User from './User';

window.Vue.component('MerchantCreateAccount', CreateAccount);
window.Vue.component('MerchantListUsers', ListUsers);
window.Vue.component('MerchantUser', User);
